import { type AxiosError } from 'axios'
import useSWRMutation, { type SWRMutationResponse } from 'swr/mutation'

import { NotepadControllerV2ApiFactory } from '@redteclab/api/clients/bully'

import { useBullyApi } from '../../../base-api-communication'
import { useGlobalConfigContext } from '../../../global-config'

const getLanguageNotepadV2TenantUpidDeleteMutationKey = (): string =>
  'LangugageNotepadV2TenantUpidDeleteMutation'

export const useLanguageNotepadV2TenantUpidDeleteMutation =
  (): SWRMutationResponse<void, AxiosError, string, { upid: string }> => {
    const config = useGlobalConfigContext()
    const client = useBullyApi(NotepadControllerV2ApiFactory)

    return useSWRMutation(
      getLanguageNotepadV2TenantUpidDeleteMutationKey(),
      async (swrKey: string, data: { arg: { upid: string } }) => {
        const response = await client.languageNotepadV2TenantUpidDelete({
          language: config.language,
          tenant: config.tenantAndEnv,
          upid: data.arg.upid,
        })

        return response.data
      },
    )
  }
